import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { AmbientBackground } from "@/components/AmbientBackground";
import { Sidebar } from "@/components/Sidebar";
import { MobileTabBar } from "@/components/MobileTabBar";
import { TopBar } from "@/components/TopBar";
import { ChatWidget } from "@/components/ChatWidget";

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(
    localStorage.getItem("sidebar_collapsed") === "true"
  );

  useEffect(() => {
    const handleToggle = (e) => {
      setCollapsed(Boolean(e.detail));
    };

    window.addEventListener("sidebar-toggle", handleToggle);
    return () => {
      window.removeEventListener("sidebar-toggle", handleToggle);
    };
  }, []);

  // Sidebar is fixed at left-4 (1rem).
  // Expanded w-64 (16rem) + gap → pl-72; collapsed w-[4.5rem] + gap → pl-24.
  return (
    <div className="app-shell">
      <AmbientBackground />
      <Sidebar />
      <main
        className={`relative z-10 px-4 sm:px-6 lg:pr-6 pb-32 lg:pb-8 transition-[padding] duration-300 ${
          collapsed ? "lg:pl-24" : "lg:pl-72"
        }`}
      >
        <div className="max-w-[1400px] mx-auto w-full">
          <TopBar />
          <div className="mt-4">
            <Outlet />
          </div>
        </div>
      </main>
      <MobileTabBar />
      <ChatWidget />
    </div>
  );
}
